const tutoringData = {
  Math: [
    {
      course: "Calc 1",
      tutors: [
        {
        name: "Santiago Ramirez",
        contact: "813-469-6698",
        },
        {
         name: "Jaily De Paula",
         contact: "732-938-0731",
        }
        ],
    },
    {
      course: "Calc 2",
      tutors: [
        {
        name: "Lukas Gibbs",
        contact: "386-216-6217",
    },
    {
    name: "Jaily De Paula",
    contact: "732-938-0731",
    }
    ],
    },
    {
      course: "Calc 3",
      tutors: [
        {
        name: "Tyrese Dorce",
        contact: "561-537-6778",
        }
    ],
    },
    {
      course: "Diff Eq",
      tutors: [
        {
        name: "Tyrese Dorce", 
        contact: "561-537-6778",
        },
        {
        name: "Santiago Ramirez",
        contact: "813-469-6698"
        }
    ],
    
    },
    {
      course: "Statistics 1",
      tutors: [{
        name: "Cali Copeland",
        contact: "386-341-3501",
      }
    ],
    },
    {
      course: "Statistics 2",
      tutors: [
        {
        name: "Jackson Le",
        contact: "754-292-9245",
        }
    ],
    },
    {
      course: "Pre-Calculus",
      tutors: [
       {
        name: "Cali Copeland",
        contact: "386-341-3501",
       }
    ],
    },
  ],
  Business: [
    {
    course: "Financial Accounting",
    tutors: [
        {
        name: "Jon Sarmento",
        contact: "813-895-4729",
        }
    ],
    },
  ],

  Science: [
    {
     course: "General Chemistry 1",
     tutors: [
        {
        name: "Jackson Le",
        contact: "754-292-9245",
        },
        {
        name: "Tyrese Dorce",
        contact: "561-537-6778",
        }
     ]
    },
    {
      course: "General Chemistry 2",
      tutors: [
        {
           name: "Jackson Le",
           contact: "754-292-9245",
        }
        , 
        {
         name: "Tyrese Dorce",
         contact: "561-537-6778",
        }
    ],
    },
    {
      course: "Organic Chemistry 1",
      tutors: [
        {
        name: "Jackson Lee",
        contact: "754-292-9245",
        }
    ],
    },
    {
      course: "Biology 1",
      tutors: [
       {
     name: "Marianne Franco",
     contact: "786-554-7369",
       }
    ],
    },
    {
      course: "Biology 2",
      tutors: [
        {
    name: "Marianne Franco",
    contact: "786-554-7369",
    }
],
    },
  ],

  Engineering: [
    {
      course: "Programming for Engineers (MATLAB)",
      tutors: [
        {
        name: "Lukas Gibbs",
        contact: "386-216-6217",
        }
    ],
    },
    {
      course: "Solidworks (EML2023)",
      tutors: [
        {
         name:   "Lukas Gibbs",
         contact: "386-216-6217",
        }

      ],
    },
    {
      course: "Programming for Engineers (Python)",
      tutors: [
        {
        name: "Tyrese Dorce",
        contact: "561-537-6778",
        }
        , 
        {
        name:  "Santiago Ramirez",
        contact: "813-469-6698",
    }
],
    },
    {
      course: "Programming for Engineers (C++)",
      tutors: [
        {
        name: "Santiago Ramirez",
        contact: "813-469-6698",
    }
],
    },
  ],

  Physics: [
    {
      course: "Physics 1",
      tutors: [
        
        {
            name: "Lukas Gibbs",
            contact: "386-216-6217",
        }
        , 
        {
           name: "Santiago Ramirez",
           contact: "813-469-6698"
    }
],
    },
  ],

  "Pre-Health": [
    {
      course: "Applied Human Physiology",
      tutors: [
        {
        name: "Jackson Le",
        contact: "754-292-9245",
    }
],
    },
    {
      course: "Developmental Psychology",
      tutors: [
        {
        name: "Anthony Rodriguez",
        contact: "786-818-3292"
        }
    ],
    },
    {
      course: "Abnormal Psychology",
      tutors: [
        {
        name: "Anthony Rodriguez",
        contact: "786-818-3292",
        }
    ],
    },
    {
    course: "Anatomy",
    tutors: [
        {
        name: "Jackson Le",
        contact: "754-292-9245",
    }
],
    },
    {
    course: "Sociology",
    tutors: [
        {
        name: "Nickolas Hebert",
        contact: "561-542-9083",
    }
],
    },

    {
      course: "Introduction to Clinical Psychology",
      tutors: [
        {
        name: "Anthony Rodriguez",
        contact: "786-818-3292",
    }
],
    },
  ],

  "Pre-Law": [
    {
      course: "Origins of the Contemporary West 1",
      tutors: [
        {
        name: "Cristian Alicea",
        contact: "305-282-2412",
        }
    ],
    },
    {
      course: "American Civil Discourse",
      tutors: [
        {
        name: "Cristian Alicea",
        contact: "305-282-2412",
        }
    ],
    },
  ],

  "Writing Classes": [
    {
      course: "Any Writing Class",
      tutors: [
        {
        name: "Cristian Alicea",
        contact: "305-282-2412"
    }
],
    },
    {
      course: "Argument and Persuasion",
      tutors: [
        {
        name: "Isaac Aristud",
        contact: "407-406-8052",
    }
],
    },
  ],

  "General Education": [
    {
      course: "Principles of Advertising",
      tutors: [
        {
        name: "Isaac Aristud",
        contact: "407-406-8052",
        }
    ],
    },
    {
      course: "Experiencing Music",
      tutors: [
        {
         name:  "Isaac Aristud",
         contact: "407-406-8052",
    }
],
    },
    {
    course: "Macro-Economics",
    tutors: [
        {
        name: "Kaiya Varner",
        contact: "352-284-1056",
    }
],
    },
    {
      course: "General Psychology",
      tutors: [
        {
        name: "Anthony Rodriguez",
        contact: "786-818-3292",
    }
],
    },
    {
    course: "Micro-Economics",
    tutors: [
        {
        name: "Kaiya Varner",
        contact: "352-284-1056",
    }
],
    },
    {
      course: "Statistics 1",
      tutors: [
        {
        name: "Cali Copeland",
        contact: "386-341-3501",
        }
    ],
    },
  ],
};

export default tutoringData;